import angular from 'angular';
import { postReadMoreComponent } from './postReadMoreComponent';

angular.module('sh.postReadMore', ['sh.api', 'sh.eventTracker']).component('shPostReadMore', postReadMoreComponent());
